import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';

function AboutMakingHome() {
  const stats = [
    {
      id: 1,
      number: '165M',
      label: 'Homes in Real Estate Living Database'
    },
    {
      id: 2,
      number: '2.4M',
      label: 'Active Rental Listing on Real Estate'
    },
    {
      id: 3,
      number: '243M',
      label: 'Average Monthly Unique Users'
    },
    {
      id: 4,
      number: '68%',
      label: 'More Time Spent On Real Estate'
    }
  ];

  return (
    <section className="about-making-home-section common-padding">
      <Container>
        <div className="common-header text-center">
          <h2>Making home a reality for more and more people</h2>
          <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. </p>
        </div>

        {/* Stats Grid */}
        <Row className="stats-row">
          {stats.map((stat) => (
            <Col lg={3} md={6} sm={6} xs={12} key={stat.id} className='br-1'>
              <div className="stat-card">
                <div className="stat-number">{stat.number}</div>
                <div className="stat-label">{stat.label}</div>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
}

export default AboutMakingHome;